<template>
  <div class="trigger-event">
    <div class="header">
      <span class="title">触发事件</span>
      <div class="info">触发事件用于外部系统向平台推送数据</div>
      <el-button type="primary" icon="el-icon-plus" @click="createTrigger()">创建触发事件</el-button>
    </div>
    <new-table ref="table" :data="triggerData" :columns="columns" :pages="pages" />
  </div>
</template>
<script>
import NewTable from "@/components/new-table.vue";
import ConnectorApis from "@/apis/connector";
import { Clipboard } from "@/utils/util";
export default {
  name: "trigger-event",
  props: {},
  mounted() {
    this.getTriggerList();
  },
  data() {
    return {
      triggerData: [],
      columns: [
        {
          label: "名称",
          render: (h, { row }) => {
            return (
              <span class="trigger-name" onClick={() => this.createTrigger(row.id)}>
                {row.triggerName}
              </span>
            );
          },
        },
        {
          label: "操作",
          width: "200px",
          render: (h, { row }) => {
            return (
              <span>
                <el-button type="text" onClick={() => this.createTrigger(row.id)}>
                  查看详情
                </el-button>
                <el-button type="text" onClick={() => Clipboard(row.id)}>
                  复制ID
                </el-button>
                <el-button type="text" onClick={() => this.delTrigger(row.id)}>
                  删除
                </el-button>
              </span>
            );
          },
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.pageChange(p);
          },
        },
      },
      connectorId: this.$route.query.id,
    };
  },
  methods: {
    getTriggerList() {
      const { currentPage, pageSize } = this.pages.props;
      ConnectorApis.getTriggerEventList(this.connectorId, currentPage, pageSize).then((res) => {
        this.triggerData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    createTrigger(id) {
      let url = `./create-trigger?connectorId=${this.connectorId}`;
      if (id) url += `&id=${id}`;
      this.$router.push(url);
    },
    async delTrigger(id) {
      await this.$confirm("确定要删除这个触发事件吗？", {
        type: "warning",
      });
      await ConnectorApis.deleTriggerEvent(id);
      this.$message.success("删除成功！");
      this.getTriggerList();
    },
  },
  components: { NewTable },
};
</script>
<style scoped lang="scss">
.trigger-event {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  .title {
    margin-right: 12px;
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
  }
  .info {
    flex: 1;
    font-size: 14px;
    line-height: 32px;
    margin-right: 12px;
    color: rgba(0, 0, 0, 0.45);
  }
}
::v-deep {
  .trigger-name {
    &:hover {
      cursor: pointer;
      color: #3d9cfc;
      text-decoration: underline;
    }
  }
}
</style>
